// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"f7d1e69e","24":"75f72627","71":"41773e74","249":"c445877d"}[chunkId] + ".js";
};